// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1fsUw","header":"MergedInvoice_header__3237t"};